require('./hireWelcomeAccountStep2.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ utilities
const { filterValidAccounts } = require('utilities/currentAccountsHelper');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const ContractsAccountInterveners = require('routes/contractsView/components/contractsAccountInterveners/contractsAccountInterveners');

// @ constants
const {
    EURO_TEXT,
    INTERVENER_LABEL_HOLDER,
    INTERVENER_LABEL_AUTHORIZED,
    INTERVENER_LABEL_EMPOWERED,
    SOLIDARITY_INFORMATION_LINK
} = require('constants/index');

class HireWelcomeAccountStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.handleSelectedAccountChange = this.handleSelectedAccountChange.bind(this);
    }

    handleSelectedAccountChange(value) {
        const {
            immAccounts,
            requestInterveners,
            setSelectedAccountValue
        } = this.props;
        const immAccount = immAccounts.getIn(['byId', value]);

        setSelectedAccountValue(value);
        requestInterveners(immAccount);
    }

    buildDropdownAccounts() {
        const {
            immAccounts,
            immStep
        } = this.props;
        const dropdownAccountsError = formatText('hireWelcomeAccount-hireWelcomeAccount_dropdownAccountsError');
        const immAccountsById = immAccounts ? immAccounts.get('byId') : null;
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        const isSelectedAccountDirty = immStep.get('isSelectedAccountDirty');
        const selectedAccount = immStep.get('selectedAccount');
        const data = { currencyAllowed : EURO_TEXT };
        const accountsIndexes = filterValidAccounts(immAccountsById, immAccounts, data);

        return (
            <DropdownAccounts
                immAccounts={immAccountsById}
                accountsIndexes={accountsIndexes.toJS()}
                blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                onAccountChange={this.handleSelectedAccountChange}
                currentAccountId={selectedAccount}
                error={isSelectedAccountDirty && !selectedAccount}
                errorMsg={dropdownAccountsError}
                showAvailableBalance
                label="contractsView-eAccountDropdownLabel"
                showInactiveAccountsAsBlocked
                loading={isBlockedAccountsLoading}
            />
        );
    }

    buildAccountInterveners() {
        const {
            addIntervener,
            flagBasedFeatures,
            removeIntervener,
            setIntervenerType,
            restoreDefaultInterveners,
            immAccounts,
            immStep
        } = this.props;
        const intervenersIsFetching = immStep.get('intervenersIsFetching');
        const selectedAccount = immStep.get('selectedAccount');
        let content;
        if (intervenersIsFetching) {
            content = <LoadingSection />;
        } else {
            content = (
                <ContractsAccountInterveners
                    accountNumber={selectedAccount}
                    setIntervenerType={setIntervenerType}
                    addIntervener={addIntervener}
                    removeIntervener={removeIntervener}
                    restoreDefaultInterveners={restoreDefaultInterveners}
                    restoreDefaultEnabled
                    immAccounts={immAccounts}
                    immContract={immStep}
                    flagBasedFeatures={flagBasedFeatures}
                    showIntervenerControls
                    hideIntervenerLinkActions
                    intervenerOptions={[
                        INTERVENER_LABEL_HOLDER,
                        INTERVENER_LABEL_AUTHORIZED,
                        INTERVENER_LABEL_EMPOWERED
                    ]}
                    hierarchicalTypeSelection
                    intervenersSubHeader="contractsView-eAccountintervenersSubHeader"
                />
            );
        }
        return content;
    }

    render() {
        const { title } = this.props;
        const accountInterveners = this.buildAccountInterveners();
        const dropdownAccounts = this.buildDropdownAccounts();

        return (
            <React.Fragment>
                <FormattedText
                    className="hire-welcome-account-step2__title"
                    value="hireWelcomeAccount-hireWelcomeAccount_step2Title"
                    injectedStrings={[title]}
                />
                {dropdownAccounts}
                {accountInterveners}
                <div className="hire-welcome-account-step2__disclaimer">
                    <OKMessage type="informative">
                        <FormattedText
                            value="hireWelcomeAccount-hireWelcomeAccount_disclaimerMessage"
                            injectedStrings={[title]}
                        />
                        <OKLink modifier="emphasize" to={SOLIDARITY_INFORMATION_LINK} target="_blank">
                            <FormattedText value="hireWelcomeAccount-hireWelcomeAccount_disclaimerLinkText"/>
                        </OKLink>
                    </OKMessage>
                </div>
            </React.Fragment>
        );
    }
}

HireWelcomeAccountStep2.propTypes = {
    addIntervener: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
    removeIntervener: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    restoreDefaultInterveners: PropTypes.func.isRequired,
    setIntervenerType: PropTypes.func.isRequired,
    setSelectedAccountValue: PropTypes.func.isRequired,
    title: PropTypes.object.isRequired,
}

module.exports = HireWelcomeAccountStep2;
